module.exports = __webpack_public_path__ + "img/64.0bcbef37.svg";